import * as React from "react";
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store/index';
import { actionCreator } from '../../../store/agents/AgentsState';
import EditCommmisionTemplate, { EditCommmisionTemplateProps } from './editcommissiontemplate';

const mapStateToProps = (state: ApplicationState): EditCommmisionTemplateProps => {
    return {
        commissionTemplate: state.agents.editingCommisionTemplate,
        isOpen: state.agents.isJustCommissionTemplateModalOpen,
    }
}

const mapDispatchToProps = () => dispatch => {
    return {
        onChange: (propertyName: string, value: any) => dispatch(actionCreator.setRunningCommissionTemplateProp(propertyName, value)),
        onSubmit: (saveOnConfirm?: boolean) => {
            dispatch(actionCreator.updateDefaultCommissionAndRefreshList());
        },
        closeModal: () => dispatch(actionCreator.toogleJustCommissionTemplateModal(false))
    }
}

export const ConnectedEditingJustCommmisionTemplate = connect<EditCommmisionTemplateProps>(mapStateToProps, mapDispatchToProps)(EditCommmisionTemplate)